<template>
  <div v-if="contactId">
    <div v-if="!isDashboardAvailable">
      <p class="text-center text-muted">No permission available for contact dashboard</p>
    </div>
    <div v-if="isDashboardAvailable">
      <div class="row no-gutter" v-if="isCreditTypeAccount">
        <div class="col-12" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceAccount)">
          <CustomerAgedBalanceChartWidget :contactId="contactId">
          </CustomerAgedBalanceChartWidget>
        </div>
      </div>
      <div class="row no-gutter" v-if="isCreditTypeAccount">
        <div class="col-12" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceAccount)">
          <AccountsReceivableSummaryWidget :contactId="contactId" :gridHeight="320" />
        </div>
      </div>
      <div class="row no-gutter">
        <div class="col-12" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceOrder) || userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceAccount)">
          <FinancialBreakdownWidget :contactId="contactId" :gridHeight="350" />
        </div>
      </div>
      <div class="row no-gutter" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceOrder)">
        <div class="col-12">
          <DashboardTabbedContentBox :gridHeight="600" large>
            <template v-slot:tablist>
              <Tab :first="true" tabid="tab-order-daily">
                <i class="tabbedbox-tab-icon fas fa-calendar-day"></i>
                <div class="tabbedbox-tab-info">
                  <div class="tabbedbox-tab-title">Daily</div>
                  <div class="tabbedbox-tab-subtitle">Order Value Chart</div>
                </div>
              </Tab>
              <Tab tabid="tab-order-monthly">
                <i class="tabbedbox-tab-icon fas fa-calendar-alt"></i>
                <div class="tabbedbox-tab-info">
                  <div class="tabbedbox-tab-title">Monthly</div>
                  <div class="tabbedbox-tab-subtitle">Order Value Chart</div>
                </div>
              </Tab>
            </template>
            <template v-slot:tabcontent>
              <TabPage :first="true" tabid="tab-order-daily" class="tabpage-padding-0">
                <OrderDailyChartWidget :gridHeight="540" :embedded="true" :contactId="contactId" />
              </TabPage>
              <TabPage tabid="tab-order-monthly" class="tabpage-padding-0">
                <OrderMonthlyChartWidget :gridHeight="540" :embedded="true" :contactId="contactId" />
              </TabPage>
            </template>
          </DashboardTabbedContentBox>
        </div>
      </div>

      <div class="row no-gutter" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceOrder)">
        <div class="col-12">
          <DashboardTabbedContentBox :gridHeight="600" large>
            <template v-slot:tablist>
              <Tab :first="true" tabid="tab-order-glass">
                <i class="tabbedbox-tab-icon fas fa-layer-group"></i>
                <div class="tabbedbox-tab-info">
                  <div class="tabbedbox-tab-title">Order Glass</div>
                  <div class="tabbedbox-tab-subtitle">Order Breakdown By Glass</div>
                </div>
              </Tab>
              <Tab tabid="tab-order-pricegroup">
                <i class="tabbedbox-tab-icon fas fa-money-check-edit-alt"></i>
                <div class="tabbedbox-tab-info">
                  <div class="tabbedbox-tab-title">Order Price Group</div>
                  <div class="tabbedbox-tab-subtitle">Order Breakdown By Price Group</div>
                </div>
              </Tab>
              <Tab tabid="tab-order-glass-squaremeterage">
                <i class="tabbedbox-tab-icon fas fa-ruler"></i>
                <div class="tabbedbox-tab-info">
                  <div class="tabbedbox-tab-title">Order Square Meterage</div>
                  <div class="tabbedbox-tab-subtitle">Order Breakdown By Glass Square Meterage</div>
                </div>
              </Tab>
              <Tab tabid="tab-order-glass-services">
                <i class="tabbedbox-tab-icon fas fa-tools"></i>
                <div class="tabbedbox-tab-info">
                  <div class="tabbedbox-tab-title">Order Glass Services</div>
                  <div class="tabbedbox-tab-subtitle">Order Breakdown By Glass Services</div>
                </div>
              </Tab>
            </template>
            <template v-slot:tabcontent>
              <TabPage :first="true" tabid="tab-order-glass" class="tabpage-padding-0">
                <OrderValueChartWidget :dateRangeType="ChartDateRangeTypes.allTime" type="orderValueGlass" title="All Orders By Glass" subTitle="Total order value broken down by glass stock type for the contact. Incl GST" :gridHeight="500" :contactId="contactId" :embedded="true" />
              </TabPage>
              <TabPage tabid="tab-order-pricegroup" class="tabpage-padding-0">
                <OrderValueChartWidget :dateRangeType="ChartDateRangeTypes.allTime" type="orderValuePriceGroup" title="All Orders By Price Group" subTitle="Total order value broken down by price group for the contact. Incl GST" :gridHeight="500" :contactId="contactId" :embedded="true" />
              </TabPage>
              <TabPage tabid="tab-order-glass-squaremeterage" class="tabpage-padding-0">
                <OrderValueChartWidget :dateRangeType="ChartDateRangeTypes.allTime" type="orderUnitsGlass" title="All Orders By Glass Square Meterage" subTitle="Total square meterage broken down by glass stock type for the contact" :gridHeight="500" :contactId="contactId" :embedded="true" />
              </TabPage>
              <TabPage tabid="tab-order-glass-services" class="tabpage-padding-0">
                <OrderValueChartWidget :dateRangeType="ChartDateRangeTypes.allTime" type="orderValueGlassService" title="All Orders By Glass Services" subTitle="Total order value broken down by glass service type for the contact. Incl GST" :gridHeight="500" :contactId="contactId" :embedded="true" />
              </TabPage>
            </template>
          </DashboardTabbedContentBox>
        </div>
      </div>

      <div class="row no-gutter" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceOrder)">
        <div class="col-12">
          <DashboardTabbedContentBox :gridHeight="600" large>
            <template v-slot:tablist>
              <Tab :first="true" tabid="tab-ncr-itemvalue">
                <i class="tabbedbox-tab-icon fas fa-money-check-edit-alt"></i>
                <div class="tabbedbox-tab-info">
                  <div class="tabbedbox-tab-title">NCR Value</div>
                  <div class="tabbedbox-tab-subtitle">NCR Item Breakdown</div>
                </div>
              </Tab>
              <Tab tabid="tab-ncr-itemcount">
                <i class="tabbedbox-tab-icon fas fa-clipboard-list-check"></i>
                <div class="tabbedbox-tab-info">
                  <div class="tabbedbox-tab-title">NCR Count</div>
                  <div class="tabbedbox-tab-subtitle">NCR Item Breakdown</div>
                </div>
              </Tab>
              <Tab tabid="tab-ncr-orderbreakdown">
                <i class="tabbedbox-tab-icon fas fa-clipboard-list-check"></i>
                <div class="tabbedbox-tab-info">
                  <div class="tabbedbox-tab-title">NCR / Order</div>
                  <div class="tabbedbox-tab-subtitle">NCR / Order Breakdown</div>
                </div>
              </Tab>
              <Tab tabid="tab-ncr-orderitembreakdown">
                <i class="tabbedbox-tab-icon fas fa-clipboard-list-check"></i>
                <div class="tabbedbox-tab-info">
                  <div class="tabbedbox-tab-title">NCR / Order Item</div>
                  <div class="tabbedbox-tab-subtitle">NCR / Order Item Breakdown</div>
                </div>
              </Tab>
            </template>
            <template v-slot:tabcontent>
              <TabPage :first="true" tabid="tab-ncr-itemvalue" class="tabpage-padding-2">
                <NCROrderChartWidget
                  :type="NCROrderChartTypes.ncrItemValue"
                  :gridHeight="450"
                  :embedded="true"
                  :showList="true"
                  :dateRangeType="ChartDateRangeTypes.allTime"
                  :contactId="contactId"
                />
              </TabPage>
              <TabPage tabid="tab-ncr-itemcount" class="tabpage-padding-2">
                <NCROrderChartWidget
                  :type="NCROrderChartTypes.ncrItemCount"
                  :gridHeight="450"
                  :embedded="true"
                  :showList="true"
                  :dateRangeType="ChartDateRangeTypes.allTime"
                  :contactId="contactId"
                />
              </TabPage>
              <TabPage tabid="tab-ncr-orderbreakdown" class="tabpage-padding-2">
                <NCROrderChartWidget
                  :type="NCROrderChartTypes.ncrOrderBreakdown"
                  :gridHeight="450"
                  :embedded="true"
                  :showList="true"
                  :dateRangeType="ChartDateRangeTypes.allTime"
                  :contactId="contactId"
                />
              </TabPage>
              <TabPage tabid="tab-ncr-orderitembreakdown" class="tabpage-padding-2">
                <NCROrderChartWidget
                  :type="NCROrderChartTypes.ncrOrderItemBreakdown"
                  :gridHeight="450"
                  :embedded="true"
                  :showList="true"
                  :dateRangeType="ChartDateRangeTypes.allTime"
                  :contactId="contactId"
                />
              </TabPage>
            </template>
          </DashboardTabbedContentBox>
        </div>
      </div>

      <div class="row no-gutter" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceAccount)">
        <div class="col-12">
          <DashboardTabbedContentBox :gridHeight="600" large>
            <template v-slot:tablist>
              <Tab :first="true" tabid="tab-invoice-daily">
                <i class="tabbedbox-tab-icon fas fa-calendar-day"></i>
                <div class="tabbedbox-tab-info">
                  <div class="tabbedbox-tab-title">Daily</div>
                  <div class="tabbedbox-tab-subtitle">Invoice Value Chart</div>
                </div>
              </Tab>
              <Tab tabid="tab-invoice-monthly">
                <i class="tabbedbox-tab-icon fas fa-calendar-alt"></i>
                <div class="tabbedbox-tab-info">
                  <div class="tabbedbox-tab-title">Monthly</div>
                  <div class="tabbedbox-tab-subtitle">Invoice Value Chart</div>
                </div>
              </Tab>
            </template>
            <template v-slot:tabcontent>
              <TabPage :first="true" tabid="tab-invoice-daily" class="tabpage-padding-0">
                <InvoiceDailyChartWidget :gridHeight="540" :embedded="true" :contactId="contactId" />
              </TabPage>
              <TabPage tabid="tab-invoice-monthly" class="tabpage-padding-0">
                <InvoiceMonthlyChartWidget :gridHeight="540" :embedded="true" :contactId="contactId" />
              </TabPage>
            </template>
          </DashboardTabbedContentBox>
        </div>
      </div>

      <div class="row no-gutter" v-if="userHasReadPermission(PermissionTypes.IntelligencePermissionTypes.intelligenceDIFOT)">
        <div class="col-12">
          <DashboardTabbedContentBox :gridHeight="630" large>
            <template v-slot:tablist>
              <Tab :first="true" tabid="tab-difot-monthly-operational">
                <i class="tabbedbox-tab-icon fas fa-truck"></i>
                <div class="tabbedbox-tab-info">
                  <div class="tabbedbox-tab-title">Operational</div>
                  <div class="tabbedbox-tab-subtitle">Monthly Operational DIFOT</div>
                </div>
              </Tab>
              <Tab tabid="tab-difot-monthly-collection">
                <i class="tabbedbox-tab-icon fas fa-dolly-flatbed"></i>
                <div class="tabbedbox-tab-info">
                  <div class="tabbedbox-tab-title">Collection</div>
                  <div class="tabbedbox-tab-subtitle">Monthly Collection Delay</div>
                </div>
              </Tab>
            </template>
            <template v-slot:tabcontent>
              <TabPage :first="true" tabid="tab-difot-monthly-operational" class="tabpage-padding-2">
                <OrderDIFOTMonthlyOperationalWidget
                  :gridHeight="500"
                  :embedded="true"
                  :contactId="contactId"
                />
              </TabPage>
              <TabPage tabid="tab-difot-monthly-collection" class="tabpage-padding-2">
                <OrderDIFOTMonthlyCollectionWidget
                  :gridHeight="500"
                  :embedded="true"
                  :contactId="contactId"
                />
              </TabPage>
            </template>
          </DashboardTabbedContentBox>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import DashboardContentBox from '@/components/dashboard/dashboardContentBox'
import DashboardTabbedContentBox from '@/components/dashboard/dashboardTabbedContentBox'
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import CustomerAgedBalanceChartWidget from '@/modules/intelligence/dashboardWidgets/customerAgedBalanceChartWidget'
import AccountsReceivableSummaryWidget from '@/modules/intelligence/dashboardWidgets/accountsReceivableSummaryWidget'
import FinancialBreakdownWidget from '@/modules/intelligence/dashboardWidgets/financialBreakdownWidget'
import OrderValueChartWidget from '@/modules/intelligence/dashboardWidgets/orderValueChartWidget'
import OrderDailyChartWidget from '@/modules/intelligence/dashboardWidgets/orderDailyChartWidget'
import OrderMonthlyChartWidget from '@/modules/intelligence/dashboardWidgets/orderMonthlyChartWidget'
import NCROrderChartWidget from '@/modules/intelligence/dashboardWidgets/ncrOrderChartWidget'
import InvoiceDailyChartWidget from '@/modules/intelligence/dashboardWidgets/invoiceDailyChartWidget'
import InvoiceMonthlyChartWidget from '@/modules/intelligence/dashboardWidgets/invoiceMonthlyChartWidget'
import OrderDIFOTMonthlyOperationalWidget from '@/modules/intelligence/dashboardWidgets/orderDIFOTMonthlyOperationalWidget'
import OrderDIFOTMonthlyCollectionWidget from '@/modules/intelligence/dashboardWidgets/orderDIFOTMonthlyCollectionWidget'

import { CreditTypes } from '@/store/types'
import { ChartDateRangeTypes } from '@/modules/intelligence/types'

export default {
  name: 'AnalyticsContactDashboard',
  components: {
    DashboardContentBox,
    DashboardTabbedContentBox,
    AnalyticsWidget,
    CustomerAgedBalanceChartWidget,
    AccountsReceivableSummaryWidget,
    FinancialBreakdownWidget,
    OrderValueChartWidget,
    OrderDailyChartWidget,
    OrderMonthlyChartWidget,
    NCROrderChartWidget,
    InvoiceDailyChartWidget,
    InvoiceMonthlyChartWidget,
    OrderDIFOTMonthlyOperationalWidget,
    OrderDIFOTMonthlyCollectionWidget
  },
  props: {
    creditType: String,
    contactId: Number
  },
  computed: {
    isCreditTypeAccount() {
      return this.creditType == CreditTypes.account
    },
    isDashboardAvailable() {
      if(this.userHasReadPermission(this.PermissionTypes.IntelligencePermissionTypes.intelligenceAccount) || this.userHasReadPermission(this.PermissionTypes.IntelligencePermissionTypes.intelligenceOrder))
        return true
      return false
    }
  },
  created() {
    this.ChartDateRangeTypes = ChartDateRangeTypes
    this.NCROrderChartTypes = NCROrderChartWidget.NCROrderChartTypes
  }
}
</script>